var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobility-content-box"},[_c('figure',{staticClass:"mobility-featured-image"},[_c('img',{attrs:{"src":_vm.getImage(_vm.data.featured_image.filename)}})]),_c('article',{staticClass:"mobility-content",domProps:{"innerHTML":_vm._s(_vm.data.content)}}),_c('mobility-form',{attrs:{"mobility-id":_vm.data.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }